import { User } from "oidc-client-ts";
import client from "./client";

const {
  settings: { authority, client_id },
} = client;

// taken from https://github.com/authts/react-oidc-context/blob/main/src/utils.ts
export const hasAuthParams = (location = window.location) => {
  // response_mode: query
  let searchParams = new URLSearchParams(location.search);
  if (
    (searchParams.get("code") || searchParams.get("error")) &&
    searchParams.get("state")
  ) {
    return true;
  }

  // response_mode: fragment
  searchParams = new URLSearchParams(location.hash.replace("#", "?"));
  if (
    (searchParams.get("code") || searchParams.get("error")) &&
    searchParams.get("state")
  ) {
    return true;
  }

  return false;
};

// initiates the sign in process
export const login = () => client.signinRedirect();

// decides how to best exchange an authorization code
export const loginCallback = () => client.signinCallback();

export const getUser = () => client.getUser();

// synchronously retrieve the user from webstorage
export const getUserSync = () => {
  const oidcStorage = sessionStorage.getItem(
    `oidc.user:${authority}:${client_id}`
  );

  if (!oidcStorage) return null;

  return User.fromStorageString(oidcStorage);
};

export const logout = () => {
  client.removeUser();
  client.signoutRedirect();
};

export const isAuthenticated = (role) => {
  let authenticated = false;

  const user = getUserSync();
  if (!user) {
    return false;
  }

  const expired = Date.now() > (user.expires_at || 0) * 1000;

  const { roles = [] } = user.profile;
  const validRoles = role ? !!roles && roles.includes(role) : !!roles;

  if (!expired && validRoles) {
    authenticated = true;
  } else {
    client.removeUser();
  }

  return authenticated;
};

/*
  Gets tokenType, accessToken, and idToken from sessionStorage and returns them.
  Use for making requests if you want something more DIY than createAuthHeaders.
*/
export const getTokenValuesForHeaders = () => {
  const user = getUserSync();
  if (!user) return {};
  const { access_token, token_type, id_token } = user;

  return {
    tokenType: token_type,
    accessToken: access_token,
    idToken: id_token,
  };
};

/*
	Takes a config object and returns a headers object extended with the config.
	Use for making requests.
  */
export const createAuthHeaders = (config) => {
  const user = getUserSync();
  if (!user) return Object.assign({}, config);
  const { accessToken, tokenType, idToken } = getTokenValuesForHeaders();

  const headers = {
    Authorization: `${tokenType} ${accessToken}`,
    Identity: idToken,
  };

  return Object.assign({}, headers, config);
};
